import React from 'react';
import { X, Check } from 'lucide-react';
const sin = ['Horas planificando desde cero cada semana', 'Ejercicios sueltos de YouTube que no funcionan en tu pileta', 'Grupos sin sistema claro de progresión', 'Alumnos que no avanzan de nivel sin saber por qué', 'Ansiedad del domingo a la noche pensando en la semana', 'No podés justificar un aumento de cuota sin sistema', 'Llegás a la pileta y improvisás sobre la marcha'];
const con = ['5 minutos. Todo listo para la semana completa', '+84 ejercicios graficados listos para imprimir y usar', 'Estructura clara para cada nivel y objetivo de clase', 'Sistema de escaneo para saber exactamente dónde está cada alumno', '15 minutos el domingo y arrancás la semana con todo claro', 'Resultados visibles que justifican tu valor profesional', 'Llegás a la pileta con todo resuelto desde el día anterior'];
export function ComparisonTable() {
  return <section className="py-20 bg-white" data-id="element-41">
      <div className="max-w-5xl mx-auto px-4" data-id="element-42">
        <div className="text-center mb-12" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900" data-id="element-44">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-0 rounded-2xl overflow-hidden shadow-2xl border border-gray-200" data-id="element-45">
          {/* SIN */}
          <div className="bg-red-50 p-8 md:p-10" data-id="element-46">
            <h3 className="text-xl font-bold text-red-800 mb-8 text-center border-b border-red-200 pb-4" data-id="element-47">
              SIN NATACIÓN 360
            </h3>
            <ul className="space-y-6" data-id="element-48">
              {sin.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-49">
                  <div className="bg-red-100 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-50">
                    <X className="w-4 h-4 text-red-600" data-id="element-51" />
                  </div>
                  <span className="text-red-900 font-medium" data-id="element-52">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* CON */}
          <div className="bg-brand-blue p-8 md:p-10 text-white relative" data-id="element-53">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 md:hidden bg-white text-brand-blue font-bold px-4 py-1 rounded-full text-sm shadow-md" data-id="element-54">
              VS
            </div>
            <h3 className="text-xl font-bold text-white mb-8 text-center border-b border-blue-400 pb-4" data-id="element-55">
              CON NATACIÓN 360
            </h3>
            <ul className="space-y-6" data-id="element-56">
              {con.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-57">
                  <div className="bg-green-400 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-58">
                    <Check className="w-4 h-4 text-brand-dark" data-id="element-59" />
                  </div>
                  <span className="text-blue-50 font-medium" data-id="element-60">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-61">
          <p className="text-2xl font-heading font-bold text-gray-900" data-id="element-62">
            El lunes podés improvisar o entrar con todo resuelto.{' '}
            <br className="hidden md:block" data-id="element-63" />
            <span className="text-brand-blue" data-id="element-64">Vos decidís.</span>
          </p>
        </div>
      </div>
    </section>;
}